<template>
  <div class="shared-list">
    <section v-for="(subQuestion, index) in subQuestions" :key="subQuestion.question_id || index" class="shared-item">
      <div class="shared-title"><strong>第 {{ index + 1 }} 小题</strong><span v-html="subQuestion.question"></span></div>
      <OptionList :value="entry(index).content" :options="options" :name="`${name}-shared-${index}`" :disabled="disabled" @input="update(index, $event)" />
    </section>
  </div>
</template>
<script>
import OptionList from './OptionList.vue'
export default { name: 'SharedOptionQuestionInput', components: { OptionList }, props: { value: { type: Array, default: () => [] }, subQuestions: { type: Array, default: () => [] }, options: { type: Array, default: () => [] }, name: { type: String, default: '' }, disabled: { type: Boolean, default: false } }, methods: { entry(index) { return this.value[index] || { name: index + 1, content: '' } }, update(index, content) { const next = this.value.map(item => ({ ...item })); next[index] = { ...this.entry(index), content }; this.$emit('input', next) } } }
</script>
<style scoped lang="scss">
@import '@/styles/tokens';
.shared-list, .shared-item { display: grid; gap: 12px; }
.shared-item { padding: 14px; border: 1px solid $color-border-light; border-radius: var(--radius-md); background: $color-background; }
.shared-title { display: flex; gap: 8px; align-items: baseline; color: $color-text-primary; line-height: 1.7; }
.shared-title strong { flex: 0 0 auto; color: $color-primary; }
</style>
